import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, createHashRouter, RouterProvider } from 'react-router';
import { ROUTER_MODE } from '@shared/config.ts';
import '@shared/styles/shared.css';
import './admin.css';
import { adminRoutes } from './routes.tsx';

const router = ROUTER_MODE === 'hash' ? createHashRouter(adminRoutes) : createBrowserRouter(adminRoutes);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
